import React from 'react';

const SvgUploadIcon = (props) => (
  <svg
    id="UploadIcon"
    viewBox="0 0 10 10"
    width="1em"
    height="1em"
    {...props}
    fill="currentColor">
    <path d="M8.6 3.6L6 1 5 0 4 1 1.4 3.6l1 1 1.9-2V8h1.4V2.6l1.9 2z" />
    <path d="M8.9 6.8v2.1H1.1V6.8H0V10h10V6.8z" />
  </svg>
);

export default SvgUploadIcon;
